export default function AttachRecommendationFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService,
  docDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isExpanded = false;
  vm.loaded = false;
  vm.loading = false;

  // Attach Event Handlers
  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleAttachFolder = _handleAttachFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshFolder();
    }
  }

  function _refreshFolder() {
    vm.loaded = false;
    loaderService.showViewLoader = true;

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        vm.loaded = true;
        loaderService.showViewLoader = false;
      });
    });
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      amDataService.getRecommendationDocumentsByFolder(vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId && assignedDoc.recommendationId === vm.recommendationId) {
                childDoc.recommendationDocumentId = assignedDoc.recommendationDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      amDataService.getRecommendationFoldersByFolder(vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId && assignedFolder.recommendationId === vm.recommendationId) {
                childFolder.recommendationFolderId = assignedFolder.recommendationFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _handleAttachFolder() {
    const dfdSave = $q.defer();

    if (vm.folder.attached) {
      amDataService.attachRecommendationFolder(vm.recommendationId, vm.folder.documentId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been attached successfully.`);
          vm.folder.recommendationFolderId = response.data.recommendationFolderId;
          $rootScope.$broadcast('refreshAMRecommendationFolders', { recommendationId: vm.recommendationId });
          $rootScope.$broadcast('refreshAMRecommendationDocuments', { recommendationId: vm.recommendationId });
          dfdSave.resolve();
        }
      });
    } else {
      amDataService.detachRecommendationFolder(vm.folder.recommendationFolderId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while detaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been detached successfully.`);
          vm.folder.recommendationFolderId = null;
          $rootScope.$broadcast('refreshAMRecommendationFolders', { recommendationId: vm.recommendationId });
          $rootScope.$broadcast('refreshAMRecommendationDocuments', { recommendationId: vm.recommendationId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachRecommendationFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService',
  'docDataService'
];
